import React, { useEffect, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'reactstrap';
import Loader from './../components/snippets/loader';

const AttendantCardReaderSubmit = (props) => {
  const buffer = useRef('');
  const lastTime = useRef(Date.now());

  useEffect(() => {
    const handleKeydown = (e) => {
      const now = Date.now();

      // Reset buffer if keys are too far apart (not a swipe)
      if (now - lastTime.current > 50) {
        buffer.current = '';
      }

      lastTime.current = now;

      if (e.key === 'Enter') {
        if (buffer.current) {
          submitCard(buffer.current);
          buffer.current = '';
        }
      } else {
        buffer.current += e.key;
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return () => window.removeEventListener('keydown', handleKeydown);
  }, []);

  const submitCard = (data) => {
    console.log('Card submitted:', data);
    props.onSubmit(data);
  };

  const { t } = props;
  return (
    <Modal isOpen={true} centered={true}>
      <div className="modal-header">
        <h4>{t('Swipe Card')}</h4>
        <button type="button" onClick={() => props.onClose()} className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
      </div>
      <ModalBody>
        <Loader />
        <input
          type="text"
          readOnly
          style={{display: 'none'}}
        />
      </ModalBody>
    </Modal>
  );
};

export default withTranslation()(AttendantCardReaderSubmit);